module.exports = __webpack_public_path__ + "img/example-bg.513ed0b0.svg";